module.exports = __webpack_public_path__ + "static/media/chevron-down.90c6ac04.svg";